const DEFAULT_GOOGLE_ANALYTICS_ID = 'G-G0R3BRCKB9';
const GOOGLE_ANALYTICS_ID_PATTERN = /^G-[A-Z0-9]+$/i;

const configuredGoogleAnalyticsId =
  process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID?.trim() ?? '';

export const GOOGLE_ANALYTICS_ID = GOOGLE_ANALYTICS_ID_PATTERN.test(
  configuredGoogleAnalyticsId,
)
  ? configuredGoogleAnalyticsId
  : DEFAULT_GOOGLE_ANALYTICS_ID;

export const GOOGLE_SEARCH_CONSOLE_CODE =
  process.env.NEXT_PUBLIC_GOOGLE_SEARCH_CONSOLE_CODE?.trim() ?? '';
